<nav>
    <ul class="toolbar-link-container">
        @for (toolbarNavItem of toolbarNavItems; track toolbarNavItem) {
            <li>
                @if (toolbarNavItem.external) {
                    <a class="toolbar-link"
                       href="{{toolbarNavItem.url}}"
                       target="_blank"
                       rel="noopener">
                        {{toolbarNavItem.label}}
                    </a>
                } @else {
                    <a class="toolbar-link"
                       routerLink="{{toolbarNavItem.url}}"
                       routerLinkActive="active-link">
                        {{toolbarNavItem.label}}
                    </a>
                }

            </li>
        }
    </ul>
</nav>
